module.exports = "<div class=\"card content\">\n  <div class=\"card-body\">\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        Work in progress site for code breaking\n        <br>\n        https://github.com/jeffj6123/codebreaking3801\n\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeffrey/Documents/web development/ciphersite/src/app/landing-page/landing-page.component.html
// module id = ../../../../../src/app/landing-page/landing-page.component.html
// module chunks = main